import { Component, ChangeDetectionStrategy, input, inject, signal } from '@angular/core';
import { MatSidenavContainer, MatSidenav, MatSidenavContent, MatSidenavModule } from '@angular/material/sidenav';
import { MatButton, MatButtonModule, MatMiniFabButton } from '@angular/material/button';
import { RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

import { NavigationLink } from '@gymautoc/common/core/models/navigation-link';
import { WINDOW } from '@gymautoc/common/core/utils/window-token';

import { UserInfoComponent } from '../user-info/user-info.component';

const BREAKPOINT_MOBILE = '768px';

/**
 * Sidebar component.
 * This component has default layout which can be customized.
 * Use customSidebar and sidebar-content for sidebar customization.
 * Use customPage and page-content for page customization.
 */
@Component({
  selector: 'gymautow-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatSidenavContainer,
    MatSidenav,
    UserInfoComponent,
    MatButton,
    RouterLinkActive,
    RouterLink,
    MatSidenavContent,
    RouterOutlet,
    MatMiniFabButton,
    MatIcon,
    MatSidenavModule,
    MatButtonModule,
  ],
})
export class SidebarComponent {
  /** Sidebar links. */
  public readonly links = input<NavigationLink[] | null>();

  /** Name of user studio. */
  public readonly studioName = input<string | null>();

  private readonly window = inject(WINDOW);

  /** Current sidenav state. */
  public readonly sidebarOpened = signal(true);

  public constructor() {
    if (this.isMobile()) {
      this.sidebarOpened.set(false);
    }
  }

  /** Handle click on navigation link. */
  protected onHandleLinkClick(): void {
    if (this.isMobile()) {
      this.sidebarOpened.set(false);
    }
  }

  private isMobile(): boolean {
    return this.window.matchMedia(`(max-width: ${BREAKPOINT_MOBILE})`).matches;
  }
}
